/** @format */

export interface ProductCatalogInput {
  includeFulfillmentFacets?: boolean;
  isFamilyPage?: boolean;
  mlBypass?: boolean;
  pageNumber: number;
  pageSize: number;
  selectedCategory?: string;
  selectedFilters?: Record<string, string[]>;
  selectedSort?: number;
  selectedStore?: string;
  snbAudience?: string;
  storeId: string;
  zipcode?: string;
  searchTerm?: string;
  sddZipcode?: string;
}
